import { Numeric2CircleIcon } from './Numeric2CircleIcon';

/**
 * author: Contributors
 * id C8CF7706-2522-4EB4-A304-C25BAD47C1C7
 * name numeric-2-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-2-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number2CircleIcon = Numeric2CircleIcon;
export default Number2CircleIcon